import axios from "axios";

const UploadModelService = {};

// =========================
// Bucket
// =========================
UploadModelService.CheckBucket = async (access_Token) => {
  return axios({
    method: "GET",
    url: "https://developer.api.autodesk.com/oss/v2/buckets",
    headers: {
      Authorization: `Bearer ${access_Token}`,
    },
  });
};

UploadModelService.CreateBucket = async (access_Token, bucket) => {
  return axios({
    method: "POST",
    url: "https://developer.api.autodesk.com/oss/v2/buckets",
    data: {
      bucketKey: bucket,
      policyKey: "persistent",
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_Token}`,
    },
  });
};

// =========================
// Signed S3 Upload
// =========================
UploadModelService.GetSignedS3UploadUrl = async (
  access_Token,
  bucket,
  objectKey,
  minutesExpiration = 15
) => {
  return axios({
    method: "GET",
    url: `https://developer.api.autodesk.com/oss/v2/buckets/${bucket}/objects/${objectKey}/signeds3upload`,
    params: {
      minutesExpiration,
      singleUse: false,
    },
    headers: {
      Authorization: `Bearer ${access_Token}`,
    },
  });
};

UploadModelService.UploadFileToSignedUrl = async (
  signedUrl,
  file,
  onUploadProgress
) => {
  return axios({
    method: "PUT",
    url: signedUrl,
    data: file,
    headers: {
      "Content-Type": "application/octet-stream",
    },
    onUploadProgress,
  });
};

UploadModelService.CompleteSignedS3Upload = async (
  access_Token,
  bucket,
  objectKey,
  uploadKey
) => {
  return axios({
    method: "POST",
    url: `https://developer.api.autodesk.com/oss/v2/buckets/${bucket}/objects/${objectKey}/signeds3upload`,
    data: {
      uploadKey,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_Token}`,
    },
  });
};

// =========================
// Model Derivative
// =========================
UploadModelService.Translate = async (access_Token, encodedUrn) => {
  return axios({
    method: "POST",
    url: "https://developer.api.autodesk.com/modelderivative/v2/designdata/job",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_Token}`,
      "x-ads-force": true,
    },
    data: {
      input: {
        urn: encodedUrn,
      },
      output: {
        destination: {
          region: "us",
        },
        formats: [
          {
            type: "svf2",
            views: ["3d", "2d"],
          },
        ],
      },
    },
  });
};

UploadModelService.ConvertFile = async (access_Token, urn) => {
  return axios({
    method: "GET",
    url: `https://developer.api.autodesk.com/modelderivative/v2/designdata/${urn}/manifest`,
    headers: {
      Authorization: `Bearer ${access_Token}`,
    },
  });
};

export default UploadModelService;